import BulkDebitPurchaseInvoiceFlow from '@Components/PurchaseInvoiceCreation/BulkDebitPurchaseInvoice/BulkDebitPurchaseInvoiceFlow';
import React from 'react';

const CreateBulkDebitPurchaseInvoice = () => {
  return (
    <div>
      <BulkDebitPurchaseInvoiceFlow />
    </div>
  );
};

export default CreateBulkDebitPurchaseInvoice;
